import IntroSection from "../../components/HomePage/Intro";
const Home = () => {
  return <IntroSection />;
};
export default Home;
